if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			this.qty = this.querySelector('.qty-selector');
			this.qtyMinus = this.querySelector('.qty-minus');
			this.qtyPlus = this.querySelector('.qty-plus');

			// --- VISUAL SYNC LOGIC (Hangar Tech) ---
			// Trust the DOM: Cerca il numero di stock visibile e usalo come limite reale.
			// Supporta sia Main Page (.stock-num) che Cards (.telemetric-value-card)
			
			try {
				const parentContext = this.closest('.product-item, .main-product, .product-quick-view__product');
				if (parentContext) {
					const stockEl = parentContext.querySelector('.stock-num, .telemetric-value-card');
					if (stockEl) {
						const stockText = stockEl.textContent.trim();
						let visualMax = null;

						// Parsing intelligente
						if (stockText.includes('ESAURITO')) {
							visualMax = 0;
						} else {
							// Estrae solo i numeri (es. "54 UNITÀ" -> 54)
							const match = stockText.match(/(\d+)/);
							if (match) {
								visualMax = parseInt(match[0]);
							} else if (stockText.includes('DISPONIBILE')) {
								// Se c'è scritto solo "DISPONIBILE" (stock infinito o nascosto), lasciamo il default (999)
								// visualMax = 999; 
							}
						}

						if (visualMax !== null) {
							// console.log('DEBUG: Visual Sync Applied (Selector). Max:', visualMax);
							this.qty.setAttribute('max', visualMax);
							// Se il valore attuale è già oltre, correggilo subito
							if (parseInt(this.qty.value) > visualMax) {
								this.qty.value = Math.max(1, visualMax);
							}
						}
					}
				}
			} catch(e) {
				console.warn('Visual Sync Error:', e);
			}
			// --- END VISUAL SYNC ---
			
			this.updateState();

			this.qty.addEventListener('change', (e)=>{
				this.updateState();
			});

			this.qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				this.updateValue(-1);
			});

			this.qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				this.updateValue(1);
			});

		}

		updateState() {
			const currentQty = parseInt(this.qty.value) || 1;
			const qtyMin = this.qty.getAttribute('min') ? parseInt(this.qty.getAttribute('min')) : 1;
			const qtyMax = this.qty.getAttribute('max') ? parseInt(this.qty.getAttribute('max')) : 999;
			const step = parseInt(this.qty.getAttribute('step')) || 1;
			// Minimo effettivo per i pulsanti +/- (nel carrello min=0 per rimozione, ma i bottoni si fermano a data-min-qty)
			const effectiveMin = this.qty.hasAttribute('data-min-qty') ? parseInt(this.qty.getAttribute('data-min-qty')) : qtyMin;

			if ( currentQty <= effectiveMin ) {
				this.qtyMinus.classList.add('disabled');
				if (currentQty < effectiveMin) {
					this.qty.value = effectiveMin;
				}
			} else {
				this.qtyMinus.classList.remove('disabled');
			}

			if ( currentQty >= qtyMax ) {
				this.qtyPlus.classList.add('disabled');
				if (currentQty > qtyMax) {
					this.qty.value = qtyMax;
					if (window.nhToast) window.nhToast('⚠️ Disponibilità limitata: massimo ' + qtyMax + ' unità.', 'error');
				}
			} else {
				this.qtyPlus.classList.remove('disabled');
			}

			// Allineamento allo step: se il valore non è un multiplo valido, arrotonda al superiore
			if (step > 1 && (currentQty - effectiveMin) % step !== 0) {
				const corrected = effectiveMin + Math.ceil((currentQty - effectiveMin) / step) * step;
				this.qty.value = Math.min(corrected, qtyMax);
			}
		}

		updateValue(delta) {
			const qtyMin = this.qty.getAttribute('min') ? parseInt(this.qty.getAttribute('min')) : 1;
			const qtyMax = this.qty.getAttribute('max') ? parseInt(this.qty.getAttribute('max')) : 999;
			const step = parseInt(this.qty.getAttribute('step')) || 1;
			// Minimo effettivo: i pulsanti +/- non scendono sotto data-min-qty
			const effectiveMin = this.qty.hasAttribute('data-min-qty') ? parseInt(this.qty.getAttribute('data-min-qty')) : qtyMin;
			let currentQty = parseInt(this.qty.value) || 1;
			let newQty = currentQty + (delta * step);

			if (newQty >= effectiveMin && newQty <= qtyMax) {
				this.qty.value = newQty;
				this.qty.dispatchEvent(new Event('change', { bubbles: true }));
			} else if (delta > 0 && currentQty >= qtyMax) {
				if (window.nhToast) window.nhToast('⚠️ Disponibilità limitata: massimo ' + qtyMax + ' unità.', 'error');
			}
			// Se delta < 0 e newQty < effectiveMin, non fare nulla (non scendere a 0)
			
			this.updateState();
		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}